/**
 * Created by Marthijn on 01-08-17.
 */
import React from 'react';
import moment from 'moment';
import {Button, Glyphicon, Label} from 'react-bootstrap';
import ModalAction from './modalAction';
import Parse from 'parse';

const COMPLETED = "completed";

export default class ActionList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            actionsJSON: [],
            display: {
                owner: props.showOwner,
                project: props.showProject,
            },
            sorting: {
                on: "deadlineTime",
                order: "up"
            },
            showModal: false,
            modalAction: {},
            currentRole: props.role,
        };

        // console.log("constructor.props", props);
    }

    componentDidMount() {
        this.loadActions(this.props.actions);
    }

    componentWillReceiveProps(props) {
        this.loadActions(props.actions);
    }

    loadActions(actions) {

        let actionsJSON = [];

        actions.forEach((action, i) => {
            let actionJSON = this.convertActionToJSON(action);

            if (actionJSON !== undefined) {
                actionsJSON.push(actionJSON);
            }
        });

        this.setState({
            actionsJSON: actionsJSON,
        });
    }

    convertActionToJSON(action) {
        const _this = this;

        let status = action.get("status");

        if (_this.state.actionId === action.id && status !== "completed") {
            action.set("status", "completed");
            action.save();
            status = "completed";
        }

        let user = action.get("user");
        let info = user.get("info");
        let deadlineMoment = moment(action.get("deadline"));
        let deadline = deadlineMoment.format("D MMM YYYY");
        let createdAtMoment = moment(action.get("createdAt"));
        let createdAt = createdAtMoment.format("D MMM YY, HH:mm");
        let deadlineStyle = "default";
        let completedAt = "";
        let showCompletedAt = false;
        if (status === COMPLETED) {
            if (action.get("completedAt") !== undefined) {
                let completedAtMoment = moment(action.get("completedAt"));
                completedAt = completedAtMoment.format("D MMM YY");
                deadlineStyle = "success";
                showCompletedAt = true;
            }
        } else {
            let deadlineDiff = deadlineMoment.diff(moment(), 'days');
            if (deadlineDiff < 0) {
                deadlineStyle = "danger";
            } else if (deadlineDiff === 0) {
                deadlineStyle = "warning";
            } else if (!isNaN(deadlineDiff)) {
                deadlineStyle = "success";
            }
        }
        if (action.get("project") !== undefined) {
            return {
                id: action.id,
                object: action,
                description: action.get("description"),
                ownerId: user.id,
                ownerInfo: info,
                owner: info.get("name"),
                project: action.get("project").get("name"),
                projectId: action.get("project").id,
                status: status,
                deadline: deadline,
                deadlineMoment: deadlineMoment,
                deadlineTime: deadlineMoment.valueOf(),
                deadlineStyle: deadlineStyle,
                createdAt: createdAt,
                createdAtTime: createdAtMoment.valueOf(),
                completedAt: completedAt,
                completedComment: action.get("completedComment"),
                showCompletedAt: showCompletedAt,
                ownerPhone: info.get("phone"),
                ownerEmail: user.get("username"),
            };
        }
        return undefined;
    }

    toggleAction(e, actionObject) {
        e.stopPropagation();
        let _this = this;
        let Action = Parse.Object.extend("Action");
        let projectQuery = new Parse.Query(Action);
        projectQuery.get(actionObject.id).then(action => {

            let status = (actionObject.status === COMPLETED) ? "" : COMPLETED;
            action.set("status", status);

            if (status === COMPLETED) {
                action.set("completedAt", new Date())
            }

            action.save().then(() => {
                // let actionsJSON = _this.state.actionsJSON;
                // this.loadActions(_this.state.actionsJSON);

                let actionsJSON = _this.state.actionsJSON;
                for (let i = 0; i < actionsJSON.length; i++) {
                    if (actionsJSON[i].id === action.id) {
                        actionsJSON[i] = _this.convertActionToJSON(action)
                    }
                }
                _this.setState({actionsJSON: actionsJSON});


            }).catch((e) => {
                console.warn(e);
            })
        }).catch((e) => {
            console.warn(e);
        })

    }

    removeAction(e, actionObject) {
        e.stopPropagation();
        let _this = this;
        if (window.confirm("Are you sure you want to archive this action?")) {
            let Action = Parse.Object.extend("Action");
            let projectQuery = new Parse.Query(Action);
            projectQuery.get(actionObject.id).then(action => {
                action.set("deleted", true);
                action.save().then(() => {
                    let actionsJSON = _this.state.actionsJSON;
                    for (let i = 0; i < actionsJSON.length; i++) {
                        let action = actionsJSON[i];
                        if (action.id === actionObject.id) {
                            actionsJSON.splice(i, 1);
                            break;
                        }
                    }
                    _this.setState({
                        actionsJSON: actionsJSON,
                    });
                }).catch((e) => {
                    console.warn(e);
                })
            }).catch((e) => {
                console.warn(e);
            })
        }

    }

    showDetails(e, action) {
        console.log(e);
        this.setState({showModal: true, modalAction: action});
    }

    closeModal(action) {
        this.setState({showModal: false});

        if (action) {
            let actionsJSON = this.state.actionsJSON;
            for (let i = 0; i < actionsJSON.length; i++) {
                if (actionsJSON[i].id === action.id) {
                    actionsJSON[i] = action;
                }
            }
            this.setState({actionsJSON: actionsJSON});
        }
    }

    sort(e, sortAttr) {
        let order = "down";
        let orderInt = -1;
        if (this.state.sorting.on === sortAttr && this.state.sorting.order === "down") {
            order = "up";
            orderInt = 1;
        }
        this.setState({
            actionsJSON: this.sortActionsJSON(this.state.actionsJSON, sortAttr, orderInt),
            sorting: {
                on: sortAttr,
                order: order,
            }
        });
    }
    sortActionsJSON(actionsJSON, sortAttr, orderInt) {
        actionsJSON.sort((a, b) => orderInt * (a[sortAttr] - b[sortAttr]));
        return actionsJSON
    }

    render() {
        return (
            <div>


                <table className="table table-striped action-list">
                    <thead>
                    <tr>
                        <th style={{width: 50}}>&nbsp;</th>
                        {this.state.display.owner &&
                        <th style={{width: 120}}>Owner</th>
                        }
                        {this.state.display.project &&
                        <th style={{width: 120}}>Project</th>
                        }
                        <th>Description</th>
                        <th className="clickable hidden-xs" style={{width: 120}}
                            onClick={e => this.sort(e, "createdAtTime")}>
                            Added&nbsp;
                            {this.state.sorting.on === "createdAtTime" &&
                            <Glyphicon glyph={"chevron-" + this.state.sorting.order}/>
                            }
                        </th>
                        <th className="clickable" style={{width: 100}} onClick={e => this.sort(e, "deadlineTime")}>
                            Deadline&nbsp;
                            {this.state.sorting.on === "deadlineTime" &&
                            <Glyphicon glyph={"chevron-" + this.state.sorting.order}/>
                            }
                        </th>
                        {(this.state.currentRole === "APL" || this.state.currentRole === "PL") &&
                        <th style={{width: 50}} className="hidden-xs">&nbsp;</th>
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.actionsJSON.filter(action => action.status !== "completed" || this.props.showCompleted).map((action) => {
                        return (
                            <tr key={action.id} className={(action.status === COMPLETED) ? "success " : ""}
                                onClick={e => this.showDetails(e, action)}>
                                <th>
                                    <Button bsSize="small"
                                            bsStyle={(action.status === "completed") ? "success" : "default"}
                                            onClick={(e) => this.toggleAction(e, action)}>
                                        {(action.status === "completed") ? (
                                            <Glyphicon glyph="ok"/>
                                        ) : (
                                            <Glyphicon glyph="ok" style={{color: "#ccc"}}/>
                                        )}
                                    </Button>
                                </th>
                                {this.state.display.owner &&
                                <th>{action.owner}</th>
                                }
                                {this.state.display.project &&
                                <th>{action.project}</th>
                                }
                                <td>
                                    {(action.completedComment &&
                                    <span><Glyphicon glyph="comment"/>&nbsp;</span>)
                                    }
                                    {action.description}
                                </td>
                                <td className="hidden-xs">{action.createdAt}</td>
                                <td>
                                    <Label bsStyle={action.deadlineStyle}>{action.deadline}</Label>
                                    {action.showCompletedAt && (
                                        <span>
                                        <br />
                                            <Label bsStyle={action.deadlineStyle} className="completed-at"><Glyphicon
                                                glyph="ok"/> {action.completedAt}</Label>
                                        </span>
                                    )}
                                </td>
                                {(this.state.currentRole === "APL" || this.state.currentRole === "PL") && (
                                    <td className="hidden-xs">
                                        <Button bsSize="small" bsStyle="danger"
                                                onClick={(e) => this.removeAction(e, action)}>
                                            <Glyphicon glyph="trash"/>
                                        </Button>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>

                <ModalAction show={this.state.showModal} action={this.state.modalAction}
                             currentRole={this.state.currentRole} close={e => this.closeModal(e)}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/actionlist.js